// Sprint 25, story-134. Small formatting helpers local to the subcontractor page. `useTranslation`
// returns raw template strings (repo convention is a plain `.replace('{key}', value)`, no i18n
// library) — `t()` here centralizes that so every component does the same substitution the same
// way.

export const t = (template: string | undefined, fallback: string, params: Record<string, string | number> = {}) => {
  let result = template || fallback;
  Object.entries(params).forEach(([key, value]) => {
    result = result.replace(new RegExp(`\\{${key}\\}`, 'g'), String(value));
  });
  return result;
};

/**
 * Money never renders as `$0` for a hidden/unset value — null renders as the "not set" caller
 * supplies. A future story-127 `MoneyValue` atom would replace this; until it lands, this keeps
 * the same null-vs-zero invariant locally.
 */
export const formatMoney = (value: number | null | undefined, notSetLabel = 'Not set'): string => {
  if (value == null) return notSetLabel;
  return value.toLocaleString('en-US', { style: 'currency', currency: 'USD', maximumFractionDigits: 0 });
};

export const formatPercent = (value: number | null | undefined): string => {
  if (value == null) return '—';
  return `${Math.round(value * 100)}`;
};
